module.exports = __webpack_public_path__ + "img/1.39e9abe4.png";